var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationSuppressWarnings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M88.713 88.748H6.653a5.117 5.117 0 0 1-4.448-2.575 5.121 5.121 0 0 1 .02-5.138l41.03-71.803a5.135 5.135 0 0 1 4.428-2.544c1.823 0 3.506.971 4.427 2.544l41.03 71.803a5.129 5.129 0 0 1-4.428 7.713z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M42.554 73.722c0-.691.12-1.312.37-1.913a4.28 4.28 0 0 1 1.032-1.513 4.7 4.7 0 0 1 1.603-1.011 6.012 6.012 0 0 1 2.104-.361c.79 0 1.492.13 2.123.36a4.627 4.627 0 0 1 1.623 1.012c.45.421.801.932 1.032 1.513.25.6.37 1.222.37 1.913a4.75 4.75 0 0 1-.37 1.903 4.428 4.428 0 0 1-1.032 1.503c-.44.43-.982.761-1.623 1.012-.63.23-1.332.35-2.123.35-.782 0-1.483-.12-2.104-.36a4.675 4.675 0 0 1-1.603-1.002 4.291 4.291 0 0 1-1.032-1.503 4.744 4.744 0 0 1-.37-1.903m8.925-10.618h-7.623l-1.082-30.772h9.777z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.775 85.464 10.533 6.224a.762.762 0 0 0-1.08 0l-3.23 3.233a.762.762 0 0 0 0 1.075l79.244 79.244a.762.762 0 0 0 1.078 0l3.232-3.232a.764.764 0 0 0 0-1.078z",
    fill: "#e52030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationSuppressWarnings);
export default __webpack_public_path__ + "static/media/operationSuppressWarnings.f57c2b0a711e3cdaac6afcd8f8455834.svg";
export { ForwardRef as ReactComponent };